module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Label":"Delete"},"fr":{"Label":"Supprimer"}}')
  delete Component.options._Ctor
}
